export const styleSheet = theme => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        marginRight: 30,
        marginBottom: 20
    },
    containerMinimal: {},
    companyMinimal: {
        display: 'flex',
        alignItems: 'center',
        letterSpacing: 1
    },
    company: {
        display: 'flex',
        alignItems: 'center',
        marginRight: 12,
        letterSpacing: 1,
        cursor: 'pointer',
        ':hover': {
            p: {
                color: theme.colors.blue08
            }
        }
    },
    ticker: {
        color: theme.colors.blue15
    },
    exchange: {
        color: theme.colors.blue15,
        opacity: 0.5,
        fontWeight: 400,
        marginTop: 2
    },
    text: {
        marginLeft: 6
    },
    identifierInitials: {
        backgroundColor: theme.colors.gray10,
        flexShrink: 0,
        width: 22,
        height: 22,
        borderRadius: 11,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '-1px 0px 2px 0px rgba(0, 0, 0, 0.2)',
        p: {
            paddingLeft: 1,
            color: theme.colors.gray06,
            letterSpacing: 1
        }
    },
    identifierIcon: {
        flexShrink: 0,
        width: 22,
        height: 22,
        borderRadius: 11,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.colors.white01,
        boxShadow: '-1px 0px 2px 0px rgba(0, 0, 0, 0.2)',
        img: {
            minHeight: '65%',
            maxHeight: '100%'
        }
    }
});
